<template>
    <rkm-layout-body title="Lista de status">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'regulacao-status-create' })"
                authorize="store-regulacao-status"
                color="primary"
            >
                Cadastrar status
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/regulacao/status/List'

export default {
    components: { List },
}
</script>